import { NoInterviewModal } from './NoInterviewModal';

export default NoInterviewModal;